










import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { API_SYSTEM_IPC } from "@/configs/Apis";

@Component
export default class Ipc extends Vue {
  @Prop({ type: String, default: () => "" })
  name!: string;

  @Prop({ type: String, default: () => "left" })
  placement!: string;

  realName = "";
  data: Array<any> = [];

  private updateData() {
    if (this.name === "") {
      this.data = [];
      return;
    }

    let ipc: string = this.name.trim();

    const firstChar = ipc.substr(0, 1);
    if (firstChar < "A" || firstChar > "H") {
      this.data = [];
      return;
    }

    if (ipc.indexOf("(") > 0) {
      ipc = ipc.substring(0, ipc.indexOf("("));
    }
    if (ipc.indexOf("（") > 0) {
      ipc = ipc.substring(0, ipc.indexOf("("));
    }
    this.realName = ipc;

    const cachedData = this.getFromCache();
    if (cachedData) {
      this.data = cachedData;
      return;
    }

    this.$http.get<Array<any>>({ url: API_SYSTEM_IPC + "?ipc=" + encodeURIComponent(this.realName), path: {} }, {}, false, false).then((data) => {
      this.data = data || [];
      this.setToCache();
    }).catch(() => "");
  }

  private getFromCache() {
    const cachedStr = window.localStorage.getItem("IPC_CACHE_" + this.realName);
    if (!cachedStr) {
      return false;
    }

    this.refreshCacheKeys();

    const cachedData = JSON.parse(cachedStr);
    return cachedData;
  }

  private setToCache() {
    this.removeOldCache(); // LRU 保留最近访问的前300个
    window.localStorage.setItem("IPC_CACHE_" + this.realName, JSON.stringify(this.data));
    this.refreshCacheKeys();
  }

  private refreshCacheKeys() {
    const cachedKeys = window.localStorage.getItem("IPC_CACHE_KEYS") || "";
    window.localStorage.setItem("IPC_CACHE_KEYS", this.realName + "#" + cachedKeys.replace(this.realName + "#", ""));
  }

  removeOldCache() {
    const cachedKeys = window.localStorage.getItem("IPC_CACHE_KEYS");
    if (!cachedKeys) {
      return;
    }

    const cachedKeyArr = cachedKeys.split("#");
    if (cachedKeyArr.length < 300) {
      return;
    }

    cachedKeyArr.pop();

    window.localStorage.setItem("IPC_CACHE_KEYS", cachedKeyArr.join("#") + "#");
  }

  mounted() {
    this.updateData();
  }

  @Watch("name")
  onNameChange() {
    this.updateData();
  }
}
